/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';

import MuiAlert from '@mui/material/Alert';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useDropzone } from 'react-dropzone';
import {
  MdAdd,
  MdArrowBack,
  MdContentCopy,
  MdExpandLess,
  MdExpandMore,
  MdFolder,
  MdRemove,
} from 'react-icons/md';

import { Grid2, Input } from '@mui/material';
import { toast } from 'react-toastify';
import { useFile } from '../../../../../hooks/file';
import api, { authHeader } from '../../../../../services/API/apiConfig';
import { currencyMask, currencyMaskString } from '../../../../styles/util';
import ToasterBox from '../../../singleComponents/toaster/ToasterBox';

import {
  AccordionDisableStyled,
  AccordionStyled,
  BtnAddNewItemsStyled,
  BtnSubmitStyled,
  ContainerButtonsStyled,
  ContainerDragAndDropAreaStyled,
  CopyToClipboardStyled,
  DragAndDropAreaStyled,
  DropzoneStyled,
  FormStyled,
  IconContainerStyled,
  LinksAndTotalStyled,
  PageSectionTitleStyled,
  RootStyled,
  SeparatorStyled,
  Subtitle2Styled,
  SwitchContainerStyled,
  SwitchStyled,
  TitlePageStyled,
  TotalStyled,
} from './NewRelease.styles';

const Alert = React.forwardRef((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));

export function NewRelease() {
  const navigate = useNavigate();
  const location = useLocation();

  const goBack = () => navigate(-1);

  const { file, setFile } = useFile();

  const barcode = JSON.parse(localStorage.getItem('ticket'));
  const user = JSON.parse(localStorage.getItem('user'));

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [suppliersData, setSuppliersData] = useState([]);
  const [constructionsData, setConstructionsData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);

  const [checked, setChecked] = useState(false);
  const [description, setDescription] = useState(null);
  const [due, setDue] = useState(null);
  const [bankSlipNumber, setBankSlipNumber] = useState();
  const [bankSlipFile, setBankSlipFile] = useState([]);
  const [supplierId, setSupplierId] = useState(null);
  const [supplierName, setSupplierName] = useState('');
  const [constructionId, setConstructionId] = useState(null);
  const [categoryId, setCategoryId] = useState(null);
  const [amount] = useState([]);
  const [total, setTotal] = useState(0);
  const [bankSlipTotal, setBankSlipTotal] = useState(0);
  const [bankSlipTotalInput, setBankSlipTotalInput] = useState(null);
  const [items, setItems] = useState([]);
  const [constructionName, setConstructionName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [addictionalInfo, setAddictionalInfo] = useState(false);
  const [budgetsItems, setBudgetsItems] = useState([]);
  const [categoryName, setCategoryName] = useState('');
  const [ocrExist, setOcrExist] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [errors, setErrors] = useState({
    construction: false,
    supplier: false,
  });

  const [openSnackBar, setOpenSnackBar] = useState(false);

  const { getRootProps, getInputProps, acceptedFiles, isDragActive } =
    useDropzone({
      'application/pdf': ['.pdf'],
      multiple: false,
    });
  const construction = JSON.parse(localStorage.getItem('constructionId'));

  function handleGoBack() {
    localStorage.removeItem('constructionId');
    goBack();
  }

  function handleChangeItems(value, index, prop) {
    const newItem = { ...items[index], [prop]: value };
    const newItems = [...items];
    newItems[index] = newItem;

    setItems(newItems);
  }

  const handleCloseSnackBar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackBar(false);
  };

  const handleChangeStatus = (event) => {
    setChecked(event.target.checked);
  };

  const handleAddNewItems = (event) => {
    event.preventDefault();
    setItems([...items, {}]);
  };

  function handleRemoveItems(selectedIndex) {
    const newItems = items.filter((_, index) => index !== selectedIndex);
    setItems(newItems);
  }

  function getItemValue(item) {
    if (item?.item_id) {
      const option = budgetsItems.find(({ id }) => id === item.item_id);
      return `${option.item_num} - ${option.description}`;
    }
    return '';
  }

  function handleChangeAmount(event, index) {
    const newItem = { ...items[index], total: event.target.value };
    const newItems = [...items];
    newItems[index] = newItem;

    let newTotal = 0;
    newItems.forEach((item) => {
      let value = item.total || '0';
      value = value.replace('.', '').replace(',', '.');
      newTotal += parseFloat(value);
    });

    setItems(newItems);
    setTotal(newTotal);
  }

  function changeAmountValue(e) {
    let { value } = e.target;
    setBankSlipTotalInput(value);
    value = value.replace('.', '').replace(',', '.');
    value = parseFloat(value);
    setBankSlipTotal(value);
    setTotal(value);
  }

  const getFieldError = () => {
    const invalidItems = items.filter((item) => {
      const values = Object.values(item).length;
      return values !== 3 && values !== 0;
    });

    if (!constructionId) return 'obra';
    if (!supplierName) return 'fornecedor';
    if (!categoryId) return 'categoria';
    if (!due) return 'vencimento';
    if (!total && !bankSlipTotal) return 'valor';
    if (invalidItems.length) return 'item de orçamento';
    return '';
  };

  function submitForm(event, willAttach) {
    event.preventDefault();

    const data = {
      payable: {
        description,
        due,
        status: checked ? 1 : 0,
        total: total || bankSlipTotal,
        bank_slip_number: bankSlipNumber,
        supplier_id: supplierId,
        construction_id: constructionId,
        category_id: categoryId || categoriesData[0]?.id || null,
        payable_items_attributes: items
          .filter((item) => item.category_id)
          .map((item) => ({
            ...item,
            total: Number(item.total.replace('.', '').replace(',', '.')),
          })),
      },
    };

    if (!constructionId) setErrors({ ...errors, construction: true });
    if (!supplierId) setErrors({ ...errors, supplier: true });

    if (total === bankSlipTotal || total === 0 || bankSlipTotal === 0) {
      const fieldError = getFieldError();

      if (fieldError) {
        setError(true);
        setErrorMessage(
          `Campo de ${fieldError} vazio. Preencha-o e tente novamente.`
        );
        setTimeout(() => {
          setError(false);
        }, 2000);
      } else {
        api
          .post('/payables', data, {
            headers: authHeader(),
          })
          .then((res) => {
            setSuccessMessage('Lançamento salvo com sucesso');
            setSuccess(true);
            setFile('');

            if (res.data.data) {
              api.post(
                `/payables/${res.data.data.id}/attachments`,
                bankSlipFile,
                {
                  headers: {
                    ...authHeader(),
                    'Content-Type': 'multipart/form-data',
                  },
                }
              );

              if (willAttach === true) {
                setTimeout(() => {
                  navigate(`/new-release/${res.data.data.id}`, {
                    state: { from: location?.state?.from || '/admin' },
                  });

                  setSuccess(false);
                }, 1500);
              } else if (willAttach === false) {
                if (isChecked) {
                  window.location.reload();
                } else {
                  setTimeout(() => {
                    if (location.state && location.state.from) {
                      navigate(location.state.from);
                    } else {
                      navigate(`/${user.user_type}`);
                    }
                    setSuccess(false);
                  }, 1500);
                }
              }
            }
          });
      }
    } else {
      setErrorMessage('A soma dos itens e o total do boleto não coincidem');
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 2000);
    }

    localStorage.removeItem('constructionId');
  }
  // TODO: está ocorrendo essa chamada quando vem da home 3 vezes, favor investigar.
  function sendFile(fileData) {
    setIsLoading(true);
    api
      .post('/payables/ocr', fileData, {
        headers: {
          ...authHeader(),
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        const { data } = res.data;
        setOcrExist(true);
        let date = moment(data.expiration_date, 'DD/MM/YYYY');
        date = date.format('YYYY-MM-DD');
        if (data.barcode) setBankSlipNumber(data.barcode);
        if (data.expiration_date) setDue(date);
        if (data.value) {
          setBankSlipTotal(data.value);
          setBankSlipTotalInput(currencyMaskString(data.value));
        }
        if (data.constructions.length === 1) {
          setConstructionId(data.constructions[0].id);
          setConstructionName(data.constructions[0].name);
        }
        if (data.constructions.length > 1) {
          setConstructionsData(data.constructions);
        }
        if (data.supplier) {
          setSupplierId(data.supplier.id);
          setSupplierName(data.supplier.name);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setErrorMessage(err.data.messages);
        setError(true);
        setIsLoading(false);
      });
  }

  function onChangeConstruction(event, value) {
    event.preventDefault();
    if (value !== null) {
      setConstructionId(value.id);
    } else {
      setConstructionId(null);
    }
  }

  function onChangeSupplier(event, value) {
    event.preventDefault();
    if (value !== null) {
      setSupplierId(value.id);
    } else {
      setSupplierId(null);
      setCategoryId(null);
      setCategoryName('');
      setCategoriesData([]);
    }
  }

  function changeNewItems() {
    setAddictionalInfo(!addictionalInfo);
    if (addictionalInfo === false) {
      setItems([{}]);
    } else {
      setBankSlipTotal(0);
      setItems([]);
    }
  }

  function handleChangeCheckbox(event) {
    setIsChecked(event.target.checked);
  }

  useEffect(() => {
    if (construction) {
      setConstructionId(construction);
    } else {
      api
        .get('/constructions', {
          headers: authHeader(),
        })
        .then((res) => {
          const onGoingConstructions = res.data.data.filter(
            (item) => !item.finished
          );
          setConstructionsData(onGoingConstructions);
          if (onGoingConstructions.length === 1) {
            setConstructionId(onGoingConstructions[0].id);
          }
        });
    }
  }, [construction]);

  useEffect(() => {
    api
      .get('/suppliers', {
        headers: authHeader(),
      })
      .then((response) => {
        const { data } = response.data;
        setSuppliersData(data);
      });

    return () => {
      setFile(null);
    };
  }, []);

  useEffect(() => {
    if (constructionId) {
      api
        .get(`/constructions/${constructionId}/budgets?array=true`, {
          headers: authHeader(),
        })
        .then((res) => {
          const { data } = res.data;
          setBudgetsItems(data.items);
        });
    }
  }, [constructionId]);

  useEffect(() => {
    const reducer = (prev, curr) => prev + curr;
    if (!barcode) {
      if (amount.length > 0) {
        const totalAmount = amount.reduce(reducer);
        setTotal(totalAmount);
      }
    }
  }, [amount, barcode]);

  useEffect(() => {
    if (constructionsData.length) {
      for (let i = 0; i < constructionsData.length; i += 1) {
        if (constructionsData[i].id === constructionId) {
          setConstructionName(constructionsData[i].name);
        }
      }
    }
  }, [constructionsData, constructionId]);

  useEffect(() => {
    if (categoriesData.length) {
      setCategoryId(categoriesData[0].id);
      setCategoryName(categoriesData[0].name);
    }
  }, [categoriesData]);

  useEffect(() => {
    const saveFile = async () => {
      const fd = new FormData();
      const bankSlipFD = new FormData();

      if (file) {
        fd.append('file', file);
        bankSlipFD.append('files[]', file);
        sendFile(fd);
        setBankSlipFile(bankSlipFD);
      } else if (acceptedFiles.length) {
        fd.append('file', acceptedFiles[0]);
        bankSlipFD.append('files[]', acceptedFiles[0]);

        sendFile(fd);
        setBankSlipFile(bankSlipFD);
      }
    };
    saveFile();
  }, [file, acceptedFiles]);

  useEffect(() => {
    if (construction) {
      setConstructionId(construction);
      setTimeout(() => {
        localStorage.removeItem('constructionId');
      }, 180000);
    }

    for (let i = 0; i < constructionsData.length; i += 1) {
      if (constructionsData[i].id === constructionId) {
        setConstructionName(constructionsData[i].name);
      }
    }
  }, [constructionId]);

  useEffect(() => {
    if (barcode) {
      let date = moment(barcode.expiration_date, 'DD/MM/YYYY');
      date = date.format('YYYY-MM-DD');
      if (barcode.barcode) setBankSlipNumber(barcode.barcode);
      if (barcode.expiration_date) setDue(date);
      if (barcode.value) {
        setBankSlipTotal(barcode.value);
        setBankSlipTotalInput(currencyMaskString(barcode.value));
      }
      if (barcode.construction) {
        setConstructionId(barcode.construction.id);
        setConstructionName(barcode.construction.name);
      }
      if (barcode.supplier) {
        setSupplierId(barcode.supplier.id);
        setSupplierName(barcode.supplier.name);
      }
    }

    setTimeout(() => {
      localStorage.removeItem('ticket');
    }, 4000);
  }, [barcode]);

  useEffect(() => {
    if (supplierId) {
      api
        .get(`/suppliers/${supplierId}`, {
          headers: authHeader(),
        })
        .then((res) => {
          const { data } = res.data;
          setCategoriesData(data.categories);
        });
    }
  }, [supplierId]);

  useEffect(() => {
    if (constructionId) setErrors({ ...errors, construction: false });
    if (supplierId) setErrors({ ...errors, construction: false });
  }, [constructionId, supplierId]);

  const Accordion =
    budgetsItems && constructionId ? AccordionStyled : AccordionDisableStyled;

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
        }}
      >
        <LinearProgress sx={{ width: '80%' }} />
      </Box>
    );
  }

  return (
    <RootStyled>
      {success && <ToasterBox message={successMessage} />}
      {error && <ToasterBox message={errorMessage} />}

      <IconButton
        onClick={() => handleGoBack()}
        style={{ margin: '30px 80px 0px 80px' }}
        size="large"
      >
        <MdArrowBack size={25} />
      </IconButton>
      <TitlePageStyled variant="h2">Lançamentos</TitlePageStyled>
      <Snackbar
        open={openSnackBar}
        autoHideDuration={4000}
        onClose={handleCloseSnackBar}
      >
        <Alert
          onClose={handleCloseSnackBar}
          severity="success"
          sx={{ width: '20%' }}
        >
          Copiado!
        </Alert>
      </Snackbar>
      <SwitchContainerStyled id="payment-switch">
        <Typography variant="subtitle2">Pagamento efetuado</Typography>
        <SwitchStyled
          checked={checked}
          onChange={handleChangeStatus}
          inputProps={{ 'aria-label': 'Switch A' }}
        />
      </SwitchContainerStyled>
      <ContainerDragAndDropAreaStyled>
        <DragAndDropAreaStyled>
          <IconContainerStyled>
            <MdFolder />
          </IconContainerStyled>
          <DropzoneStyled id="payment-dropdown">
            <div
              {...getRootProps()}
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <input {...getInputProps()} multiple={false} id="text" />
              {isDragActive ? (
                <Typography>Solte aqui...</Typography>
              ) : (
                <Typography>Arraste o boleto</Typography>
              )}
            </div>
          </DropzoneStyled>
          {isLoading && <CircularProgress />}
        </DragAndDropAreaStyled>
        <div className="paragraphy">
          <Subtitle2Styled variant="subtitle2">
            Dica: Caso esse lançamento tenha um boleto, basta colocá-lo dentro
            da área pontilhada.
          </Subtitle2Styled>
          <Subtitle2Styled variant="subtitle2">
            As informações serão preenchidas automaticamente.
          </Subtitle2Styled>
        </div>
      </ContainerDragAndDropAreaStyled>
      <FormStyled onSubmit={submitForm}>
        <PageSectionTitleStyled variant="h3">
          Informações sobre o lançamento
        </PageSectionTitleStyled>
        <Box id="payment-info" sx={{ flexGrow: 1 }}>
          <Grid2 container spacing={2}>
            {!construction && (
              <Grid2 item size={6}>
                <Autocomplete
                  options={constructionsData}
                  value={constructionId}
                  onChange={(event, newValue) =>
                    onChangeConstruction(event, newValue)
                  }
                  inputValue={constructionName}
                  onInputChange={(_event, newInputValue) =>
                    setConstructionName(newInputValue)
                  }
                  getOptionLabel={(option) => option.name || constructionName}
                  isOptionEqualToValue={(option, value) =>
                    option.id || value.id
                  }
                  noOptionsText="Nenhuma obra encontrada"
                  renderInput={(params) => (
                    <TextField
                      required
                      error={errors.construction}
                      {...params}
                      label="Obra"
                      variant="outlined"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      value={constructionName}
                    />
                  )}
                />
              </Grid2>
            )}
            <Grid2 item size={6}>
              <Autocomplete
                fullWidth
                options={suppliersData}
                value={supplierId}
                onChange={(event, newValue) =>
                  onChangeSupplier(event, newValue)
                }
                inputValue={supplierName}
                onInputChange={(event, newInputValue) =>
                  setSupplierName(newInputValue)
                }
                getOptionLabel={(options) => options.name || supplierName}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                noOptionsText="Nenhum fornecedor encontrado"
                renderInput={(params) => (
                  <TextField
                    error={errors.supplier}
                    {...params}
                    label="Fornecedor"
                    variant="outlined"
                    slotProps={{
                      inputLabel: { shrink: true },
                    }}
                    value={supplierName}
                    required
                  />
                )}
              />
            </Grid2>
            <Grid2 item size={6}>
              <TextField
                error={(ocrExist || barcode) && !bankSlipNumber}
                label="Código de boleto"
                variant="outlined"
                style={{ width: '100%' }}
                slotProps={{
                  inputLabel: { shrink: true },
                }}
                value={bankSlipNumber}
                onChange={(ev) => setBankSlipNumber(ev.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <CopyToClipboard
                        text={bankSlipNumber}
                        onCopy={() => setOpenSnackBar(!openSnackBar)}
                      >
                        <CopyToClipboardStyled
                          disabled={!bankSlipNumber}
                          size="large"
                        >
                          <MdContentCopy size={19} />
                        </CopyToClipboardStyled>
                      </CopyToClipboard>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid2>
            <Grid2 item size={6}>
              <Autocomplete
                options={categoriesData}
                getOptionLabel={(options) => options.name || categoryName}
                onChange={(_, newValue) => setCategoryId(newValue?.id || null)}
                value={categoryId}
                inputValue={categoryName}
                onInputChange={(_, newInputValue) => {
                  setCategoryName(newInputValue);
                }}
                disabled={!categoriesData.length}
                sx={{ '.MuiInputBase-input': { height: 21 } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Categoria do fornecedor"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    value={categoryName}
                  />
                )}
              />
            </Grid2>
            <Grid2 item size={6}>
              <TextField
                fullWidth
                label="Descrição"
                variant="outlined"
                value={description}
                onChange={(ev) => setDescription(ev.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid2>
            <Grid2 item size={3}>
              <TextField
                error={(ocrExist || barcode) && !due}
                label="Vencimento"
                variant="outlined"
                type="date"
                required
                slotProps={{
                  inputLabel: { shrink: true },
                }}
                fullWidth
                value={due}
                onChange={(ev) => setDue(ev.target.value)}
              />
            </Grid2>
            {!addictionalInfo && (
              <Grid2 item size={3}>
                <TextField
                  required
                  error={(ocrExist || barcode) && !bankSlipTotalInput}
                  label="Valor"
                  variant="outlined"
                  disabled={ocrExist}
                  value={bankSlipTotalInput}
                  fullWidth
                  onChange={(e) => changeAmountValue(currencyMask(e))}
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">{' R$ '}</InputAdornment>
                    ),
                  }}
                />
              </Grid2>
            )}
          </Grid2>
        </Box>
        <Accordion
          id="budget-association"
          onClick={budgetsItems && constructionId ? changeNewItems : undefined}
        >
          <Typography variant="h3" style={{ color: '#1c1c1c' }}>
            Associar a itens do orçamento
          </Typography>
          <div style={{ paddingRight: 16 }}>
            {addictionalInfo ? (
              <MdExpandMore size={24} />
            ) : (
              <MdExpandLess size={24} />
            )}
          </div>
        </Accordion>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            margin: '40px 0 25px 0',
          }}
        >
          {addictionalInfo && (
            <Grid2 container spacing={2} sx={{ width: '100%' }}>
              {items.length > 0
                ? items.map((item, index) => (
                    <>
                      <Grid2 item size={3}>
                        <Autocomplete
                          options={categoriesData}
                          getOptionLabel={(options) => options.name}
                          onChange={(e, newValue) => {
                            handleChangeItems(
                              newValue.id,
                              index,
                              'category_id'
                            );
                            setAddictionalInfo(true);
                          }}
                          sx={{ '.MuiInputBase-input': { height: 21 } }}
                          noOptionsText="Necessário selecionar um fornecedor"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              error={!supplierId}
                              label="Categoria do fornecedor"
                              variant="outlined"
                              slotProps={{
                                inputLabel: { shrink: true },
                              }}
                            />
                          )}
                        />
                      </Grid2>
                      <Grid2 item size={4}>
                        <Autocomplete
                          options={budgetsItems}
                          getOptionLabel={(options) =>
                            `${options.item_num} - ${options.description}`
                          }
                          getOptionDisabled={(option) => {
                            const itemNumbers = budgetsItems.map(
                              ({ item_num: number }) => number
                            );
                            return itemNumbers.some((num) =>
                              num.startsWith(`${option.item_num}.`)
                            );
                          }}
                          onChange={(e, value) => {
                            handleChangeItems(value?.id, index, 'item_id');
                          }}
                          sx={{ '.MuiInputBase-input': { height: 21 } }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Item do orçamento"
                              variant="outlined"
                              slotProps={{
                                inputLabel: { shrink: true },
                              }}
                            />
                          )}
                        />
                      </Grid2>
                      <Grid2 item size={3}>
                        <TextField
                          sx={{ width: '100%', height: '100%' }}
                          value={item.total}
                          label="Valor"
                          variant="outlined"
                          onChange={(e) => {
                            handleChangeAmount(currencyMask(e), index);
                          }}
                          slotProps={{
                            inputLabel: { shrink: true },
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                {' R$ '}
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid2>
                      <Grid2 item container alignItems="center" size={1}>
                        <Grid2 item size={6}>
                          <BtnAddNewItemsStyled
                            onClick={handleAddNewItems}
                            size="small"
                          >
                            <MdAdd size={22} />
                          </BtnAddNewItemsStyled>
                        </Grid2>
                        <Grid2 item size={6}>
                          <BtnAddNewItemsStyled
                            onClick={() => handleRemoveItems(index)}
                            size="small"
                          >
                            <MdRemove size={22} />
                          </BtnAddNewItemsStyled>
                        </Grid2>
                      </Grid2>
                    </>
                  ))
                : null}
            </Grid2>
          )}
        </div>
        <div>
          <LinksAndTotalStyled>
            <div />
            <div id="total-value">
              <TotalStyled variant="h4">VALOR TOTAL</TotalStyled>
              <TotalStyled color="secondary" variant="h3">
                {bankSlipTotal
                  ? new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    }).format(bankSlipTotal || 0)
                  : new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    }).format(total || 0)}
              </TotalStyled>
            </div>
          </LinksAndTotalStyled>
        </div>
        <ContainerButtonsStyled>
          <div>
            <FormControlLabel
              id="new-release-radio"
              style={{ fontSize: '12px' }}
              label="Criar novo lançamento"
              control={
                <Checkbox
                  checked={isChecked}
                  onChange={(e) => handleChangeCheckbox(e)}
                />
              }
            />

            <div>
              <BtnSubmitStyled
                id="save-btn"
                variant="contained"
                color="secondary"
                onClick={(e) => submitForm(e, false)}
              >
                Salvar
              </BtnSubmitStyled>
              <BtnSubmitStyled
                id="save-and-attach-btn"
                disabled={isChecked}
                variant="contained"
                onClick={(e) => submitForm(e, true)}
              >
                Salvar e anexar
              </BtnSubmitStyled>
            </div>
          </div>
        </ContainerButtonsStyled>
      </FormStyled>
    </RootStyled>
  );
}
